import { createContext, useContext } from 'react';
import { Content as SelectPrimitiveContent } from '@radix-ui/react-select';
import type { SelectValueAdapter } from './adapter';
import type { ValueType } from './types';

export type SelectContextType = {
  side: 'top' | 'bottom';
  setSide: (side: 'top' | 'bottom') => void;
  contentRef: React.RefObject<React.ElementRef<typeof SelectPrimitiveContent>>;
  adapter: SelectValueAdapter<ValueType>;
};

export const InternalSelectContext = createContext<SelectContextType | null>(null);

export const useInternalSelectContext = () => {
  const context = useContext(InternalSelectContext);
  if (!context) {
    throw new Error('useInternalSelectContext must be used within a Select');
  }
  return context;
};
